import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=d06a102c&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d06a102c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d06a102c')) {
      api.createRecord('d06a102c', component.options)
    } else {
      api.reload('d06a102c', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=d06a102c&scoped=true&", function () {
      api.rerender('d06a102c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8435DR4Gbw8yL/JS/comp/Accordion.vue"
export default component.exports